export const container = () => ({
    position: 'relative',
    width: '100%',

    tabletLarge: {},
});
